import './post_view.js.coffee'
Namespace 'Monitoring.Reports.Campaign'

class Monitoring.Reports.Campaign.FacebookPostView extends Monitoring.Reports.Campaign.PostView
  className: "facebook-content"
  facebookPreview: JST['backbone/templates/monitoring/reports/campaign/post_preview_facebook']
  ownPreview: JST['backbone/templates/monitoring/previews/facebook_post_preview']

  initialize: (@options = {}) =>
    # just set @options

  getPreviewTemplate: ->
    useFacebookPreview = false
    useFacebookPreview = @options.visualization.facebook_widget if @options.visualization?
    if useFacebookPreview
      @facebookPreview
    else
      @ownPreview

  getPreview: ->
    @getPreviewTemplate()({
      post: @options.post
      campaign: false
      post_id: @options.post.post_id
      user: @options.post.user
    })

  customSections: =>
    sections = [
      new Monitoring.Reports.Campaign.PostInsightsView($.extend({}, @options, { paginate: true }))
    ]

  renderPreview: =>
    @$('[data-view=post-preview]').append(@getPreview())
